/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ConfirmBtnAccCreation from "../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import GstDetails from "../../../../components/_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../components/_utils/AccountCreationComponents/PanDetails";
import ActiveInactiveAssociatePopup from "../../../../components/_utils/ActiveInactiveAssociatePopup";
import CommonLayout from "../../../../components/_utils/CommonLayout";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import GSTVerification from "../../../../containers/Settings/GSTDetails";
import {
  beneVerifyThisGST,
  resetBeneVerifyThisGst,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import "./index.css";

const CreatePan = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  setLookupNext,
  lookupNext,
  BenEnableNextButton,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  disableCreateNext,
  setDisableCreateNext,
  previousId,
  beneLookError,
  setPreviousBankNo,
  setPayload,
  payload,
  handleDeSelectConfirm,
  GSTStatus,
  setGSTStatus,
  setNewData,
  type,
}) => {
  const dropDownOptions = [
    "Reimbursement account",
    "Field force account",
    "Beneficiary account",
    "Tax account",
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );
  const { beneVerifyGST, isGSTLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(dropDownOptions[0]);
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [GSTLinked, setGSTLinked] = useState(false);

  const prefilledGST =
    viewAccountDetailData?.beneficiary_accounts?.[0]?.gstin_detail || "";

  useEffect(() => {
    if (payload?.gstin?.length === GlobalConfiguration?.gstLength) {
      let aa = payload?.gstin?.substring(
        GlobalConfiguration?.lengthCheckTwo,
        payload?.gstin?.length - GlobalConfiguration?.lengthCheckThree,
      );
      if (aa === panNumber && beneVerifyGST?.status === true) {
        setDisableCreateNext(true);
        setLookupNext(true);
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);
        if (aa !== panNumber && beneVerifyGST?.status === true) {
          setGSTLinked(false);
        }
        BenEnableNextButton(true);
      }
    } else if (
      payload?.gstin?.length === 0 &&
      verifiedPan &&
      !verifyPANisLoading
    ) {
      setGSTStatus(null);
    }
  }, [
    beneVerifyGST,
    GSTStatus,
    gstVerified,
    payload?.gstin,
    verifyPANisLoading,
  ]);

  useEffect(() => {
    if (!beneLookData?.status) {
      let aa = payload.gstin.substring(2, payload.gstin.length - 3);
      if (!GSTStatus && GSTStatus != null) {
        BenEnableNextButton(true);
      } else if (GSTStatus && disableCreateNext && aa === panNumber) {
        BenEnableNextButton(false);
      }
    }
  }, [GSTStatus]);

  useEffect(() => {
    if (!beneLookData?.status) {
      let aa = payload.gstin.substring(2, payload.gstin.length - 3);
      if (
        verifiedPan === true &&
        GSTStatus &&
        payload?.gstin?.length > 0 &&
        payload?.gstin?.length === 15 &&
        gstVerified === true &&
        aa === panNumber
      ) {
        BenEnableNextButton(false);
      } else if (
        !beneLookLoading &&
        !verifyPANisLoading &&
        beneLookError === true &&
        verifiedPan &&
        panNumber?.length === 10 &&
        payload?.gstin?.length === 0
      ) {
        BenEnableNextButton(false);
      } else {
        BenEnableNextButton(true);
      }
    }
  }, [gstVerified, GSTStatus]);

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData =
        viewAccountDetailData?.reimbursement_accounts?.[0];
      if (beneficiaryData) {
        setPayload((prevPayload) => ({
          ...prevPayload,
          gstin: beneficiaryData.gstin_detail || "",
        }));

        if (beneficiaryData.gstin) {
          dispatch(
            beneVerifyThisGST({
              gstin: beneficiaryData.gstin,
            }),
          );
        }
      }
    }
  }, [viewAccountDetailData, viewAccountDetailLoading, dispatch]);

  useEffect(() => {
    if (payload?.gstin?.length === 15 && !customErrors["gstin"]) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));

      dispatch(beneVerifyThisGST({ search_string: payload.gstin }));
    }
  }, [payload?.gstin]);

  useEffect(() => {
    if (!isGSTLoading) {
      if (beneVerifyGST?.status === true) {
        setGstVerified(true);
      } else if (beneVerifyGST?.status === false) {
        setGstVerified(false);
      } else {
        setGstVerified(null);
      }
    }
  }, [beneVerifyGST, isGSTLoading]);

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));
    if (value) {
      setNewData({ [name]: value });
    }
    setNewData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value.length === 1) {
        return;
      }

      if (newValue.length < 15 && newValue.length > 0) {
        setGstVerified(false);
        setGSTStatus(false);
        setGSTLinked(false);
      }

      if (name === "gstin") {
        setLookupNext(false);
        dispatch(resetBeneVerifyThisGst());
        if (
          name === "gstin" &&
          newValue.length < 15 &&
          newValue.length > 0 &&
          !gstVerified &&
          GSTStatus
        ) {
          setGSTStatus(false);
        } else if (newValue.length === 15 && gstVerified && !GSTStatus) {
          setGSTStatus(true);
        }
      }
    }
  };

  useEffect(() => {
    if (
      payload?.gstin?.length > GlobalConfiguration?.lengthCheckZero &&
      payload?.gstin?.length === GlobalConfiguration?.gstLength &&
      beneVerifyGST?.status === true
    ) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
      setGSTStatus(true);
    }

    if (
      payload?.gstin?.length > GlobalConfiguration?.lengthCheckZero &&
      beneVerifyGST?.errors
    ) {
      let errors = { ...customErrors };
      errors["gstin"] = beneVerifyGST.errors;
      setCustomErrors(errors);
      setGSTStatus(false);
    }
  }, [beneVerifyGST]);

  const isPanValid = verifiedPan === true;

  const isGstValid =
    payload?.gstin?.length === 0 || // GST optional
    (payload?.gstin?.length === 15 && GSTStatus === true);

  const isConfirmDisabled = !isPanValid || !isGstValid;

  const isSwitchAccountLocked =
    type === "switch_account" &&
    prefilledGST?.length === GlobalConfiguration?.gstLength &&
    payload?.gstin === prefilledGST &&
    gstVerified === true;

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.forEach((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [beneLookData]);

  useEffect(() => {
    if (beneVerifyGST?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: beneVerifyGST?.gstin_details?.business_name,
      });
    }
  }, [beneVerifyGST]);

  return (
    <div className="w-width-full">
      {showPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: beneVerifyGST?.gstin_details?.gstin_no,
            })
          }
          closeiconhandleFunction={() => setShowPopup(false)}
        >
          <GSTVerification
            gst_number={beneVerifyGST?.gstin_details?.gstin_no}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <PanDetails
              verifiedPan={verifiedPan}
              verifyPANisLoading={verifyPANisLoading}
              panNumber={panNumber}
              handlePanChange={(e) => {
                handlePanChange(e);
              }}
              panDetails={panDetails}
              type={type}
            />
            <div
              className={`w-width-full ${isSwitchAccountLocked ? "opacity-light-opacity" : "opacity-base-opacity"}`}
              style={{
                display: !verifiedPan ? "none" : "",
              }}
            >
              <GstDetails
                verifiedPan={verifiedPan}
                gstVerified={gstVerified}
                beneVerifyGST={beneVerifyGST}
                isGSTLoading={isGSTLoading}
                GSTLinked={GSTLinked}
                GstNumber={payload?.gstin}
                setShowPopup={setShowPopup}
                handleChange={handleChange}
                type={type}
                isSwitchAccountLocked={isSwitchAccountLocked}
              />
            </div>
          </div>

          {verifiedPan === true ? (
            <div className="w-width-full flex flex-col lg:max-w-[var(--create-box-width)]">
              <ConfirmBtnAccCreation
                type="pan"
                status={beneLookData?.status}
                lookupNext={lookupNext}
                GSTStatus={GSTStatus}
                isButtonDisabled={
                  isConfirmDisabled ||
                  (panNumber.length > GlobalConfiguration?.lengthCheckZero &&
                    type === "switch_account")
                }
                isGSTLoading={isGSTLoading}
                selected={
                  "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                }
                not_selected={
                  "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                }
                handleClick={() => {
                  if (isConfirmDisabled || type === "switch_account") return;
                  setIsApproved(false);
                  setLookupNext(true);
                  setIsArchived(false);
                  setIsDennied(false);
                  setIsPending(false);
                  setDisableCreateNext(false);
                  if (lookupNext) {
                    handleDeSelectConfirm();
                  }
                  setDisableCreateNext(true);
                }}
              />

              <div
                style={{
                  visibility:
                    (beneLookData?.status &&
                      panNumber?.length === GlobalConfiguration.panLength) ||
                    (!beneLookLoading &&
                      !verifyPANisLoading &&
                      beneLookError === true &&
                      verifiedPan &&
                      panNumber?.length === GlobalConfiguration.panLength)
                      ? "visible"
                      : "hidden",
                }}
              >
                <ActiveInactiveAssociatePopup
                  flow={
                    !beneLookLoading &&
                    !verifyPANisLoading &&
                    beneLookError === true &&
                    verifiedPan &&
                    panNumber?.length === GlobalConfiguration.panLength
                      ? "notFound"
                      : "Pan"
                  }
                  dropDownOptions={dropDownOptions}
                  pan={payload?.panNumber}
                  accActiveInactiveState={accActiveInactiveState}
                  setAccActiveInactiveState={setAccActiveInactiveState}
                  currentAssociate={currentAssociate}
                  setCurrentAssociate={setCurrentAssociate}
                  openAssociatePopup={openAssociatePopup}
                  setOpenAssociatePopup={setOpenAssociatePopup}
                />
              </div>
            </div>
          ) : (
            <div
              className="w-width-full"
              style={{
                visibility: "hidden",
              }}
            ></div>
          )}
        </CommonLayout>
      </div>
    </div>
  );
};
export default CreatePan;
